import Counter from "../../../../src/components/counter.js";
import * as React from 'react';
export default {
  Counter,
  React
};